module.exports = require("./createClass.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/create-class.js
 ** module id = 292
 ** module chunks = 0
 **/